import { ScriptJobTeaserModule } from 'ui/components';

export const ScriptJobTeaserModuleFeature: React.FC<Content.ScriptJobTeaserModule> = ({ content }) => {
	return (
	<ScriptJobTeaserModule {...content?.properties}  />
)};
